export default __webpack_public_path__ + "static/media/Nitin.d3ad7481.png";